import { QuestionCourseApiService } from '../data_source/question_course_api_service';
import { QuestionCourseRepository } from '../../domain/repository/question_course_repository';
import { QuestionCourseInterface } from '../../domain/interface/question_course_interface';

export class QuestionCourseRepositoryImpl implements QuestionCourseRepository {
  private readonly questionCourseApiService: QuestionCourseApiService;

  constructor() {
    this.questionCourseApiService = new QuestionCourseApiService();
  }

  async getStartQuestionCourse(): Promise<QuestionCourseInterface[]> {
    const response = await this.questionCourseApiService.getStartQuestionCourse();
    return response.data;
  }

  async getEndQuestionCourse(): Promise<QuestionCourseInterface[]> {
    const response = await this.questionCourseApiService.getEndQuestionCourse();
    return response.data;
  }
}
